/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react'
import { bool, func, string } from 'prop-types'

import NumberField from '@groovehq/internal-design-system/lib/components/NumberField/NumberField'
import Field from '@groovehq/internal-design-system/lib/components/Field/Field'
import { styles as mainStyles } from 'components/integrations/ShopifyV2WidgetCard/styles'

import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'

import { moneyString } from 'util/currency'

import { styles } from './AdditinalInfo.styles'

const refundShippingDefault = {
  name: 'refundShipping',
  label: 'Refund shipping',
  placeholder: '0.00',
  min: 0,
}

const AdditinalInfo = React.memo(
  ({
    register,
    className,
    currencyCode,
    maxShippingValue,
    isCalculating,
    onShippingChange,
  }) => {
    const [amountField, setAmountField] = useState(refundShippingDefault)

    const maxShippingString = moneyString({
      currencyCode,
      amount: maxShippingValue,
    })

    const handleFieldChange = useCallback(
      e => {
        const rawValue = e.target.value
        const value = rawValue === '' ? 0 : parseFloat(rawValue)
        if (value * 100 < maxShippingValue) {
          setAmountField({ ...amountField, value: rawValue, help: null })
          onShippingChange(value)
        } else {
          setAmountField({
            ...amountField,
            value: rawValue,
            help: `You can refund at most ${maxShippingString}`,
            validateStatus: 'error',
          })
          onShippingChange(maxShippingValue / 100)
        }
      },
      [onShippingChange, maxShippingValue, amountField, maxShippingString]
    )

    return (
      <div className={className} css={styles.base}>
        {maxShippingValue > 0 && (
          <div className="grui mb-11">
            <NumberField
              tagPosition="left"
              tagContent={currencyCode}
              className="grui mb-3"
              disabled={isCalculating}
              {...amountField}
              onChange={handleFieldChange}
              step="any"
            />
            <p css={[paragraph.styles.preflight, text.styles.textMediumDark]}>
              <span>
                <span css={mainStyles.moneyString}>{maxShippingString}</span>{' '}
                available for refund
              </span>
            </p>
          </div>
        )}
        <Field
          {...register('refundReason')}
          className="reason"
          label="Reason for refund"
          placeholder="Only you and other staff can see this reason."
          disabled={isCalculating}
        />
      </div>
    )
  }
)

AdditinalInfo.propTypes = {
  className: string,
  currencyCode: string,
  calculating: bool,
  onShippingChange: func,
}

AdditinalInfo.defaultProps = {
  className: undefined,
  currencyCode: '',
  calculating: false,
  onShippingChange() {},
}

export default AdditinalInfo
